var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sg-img',{style:({ width: (_vm.size + "px"), height: (_vm.size + "px") }),attrs:{"src":("flags/" + ((_vm.country || 'GB').toLowerCase()) + ".png"),"placeholder-ratio":"square"}})}
var staticRenderFns = []

export { render, staticRenderFns }